export enum LoadingType {
  LOADING = 'loading-start',
  STOPPED = 'loading-stopped'
}
